<template>
  <LoadingScreen v-if="loading" :loading="loading" :messages="loadingMessages"/>
  <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; width: 100%">
  <div class="content">
    <Logo/>
    <div class="container">
      <svg class="update-status-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z"></path>
      </svg>
      <h1 class="title">Please Confirm Status Update:</h1>
      <p class="booking-ref">Referral ID: <strong>{{ referral.referralId }}</strong><br>Status:
        <strong>{{ referral.status }}</strong></p>
      <div style="display: flex; justify-content: center">
        <button @click="updateStatus" class="action-button">Update Status</button>
      </div>
    </div>
  </div>
  <Footer/>
  </div>
</template>

<script>
import Logo from "./components/Logo";
import Footer from "./components/Footer";
import LoadingScreen from "./components/LoadingScreen";

export default {
  components: {
    Logo,
    Footer,
    LoadingScreen
  },
  data() {
    return {
      loading: false,
      loadingMessages: [
        "Hang tight — we're updating the referral's status"
      ],
      referral: {
        referralId: Number(this.$route.params.referralId),
        bankUUID: this.$route.params.partnerBankUuid,
        status: this.$route.params.status
      }
    };
  },
  computed: {
    apiUrl() {
      return `${process.env.VUE_APP_API_ENDPOINT}referral-status`;
    }
  },
  methods: {
    updateStatus() {
      this.loading = true;
      let responseData;
      this.$http.post(this.apiUrl, this.referral)
          .then((res) => {
            responseData = {
              success: true,
              headerMessage: 'Referral Status Updated',
              subHeaderMessage1: `Referral ID: <strong>${this.referral.referralId}</strong>`,
            };
          })
          .catch((error) => {
            responseData = {
              success: false
            };
          })
          .finally(() => {
            this.$router.push({
              path: '/confirmation',
              state: responseData
            });
            this.loading = false;
          });
    }
  }
};
</script>

<style scoped>

.update-status-icon {
  color: #001F5A;
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}

</style>
